import colors from "../colors"
import AnnotationLegend from "../../components/DistributionChart/AnnotationLegend"

export const highlightPass = {
    text: {
      background: colors.highlight1,
      color: colors.black,
      padding: "1px 4px",
    },
    circle: {
      stroke: colors.highlight1,
      fill: colors.highlight1,
      strokeWidth: 1,
    },
    circleOutline: {
      stroke: colors.highlight1,
      fill: colors.black,
      strokeWidth: 1,
    },
  },
  highlightFail = {
    text: {
      background: colors.black,
      color: colors.highlight2,
      padding: "1px 4px",
    },
    circle: {
      stroke: colors.highlight2,
      fill: colors.highlight2,
      strokeWidth: 1,
    },
    circleOutline: {
      stroke: colors.highlight2,
      fill: colors.black,
      strokeWidth: 1,
    },
  }

export const distribution_annotations = [
  {
    id: "lang-req-1",
    content: (
      <>
        We used Rotterdam’s fraud algorithm to calculate the risk scores for
        both Sara and Yusef as well as more than 12,700 real welfare recipients
        sourced from the city’s own training data.
      </>
    ),
    content2: (
      <>
        Rotterdam considers the top 10 percent of welfare recipients in this
        data set to be “high risk." This chart shows the distribution of scores
        for a random selection of 1,000 welfare recipients. Each dot represents
        an individual person’s risk score.
      </>
    ),
  },
  {
    id: "lang-req-2",
    content: (
      <>
        Filled circles <AnnotationLegend type="fill" /> are people who have not
        met their Dutch language requirement. Empty circles{" "}
        <AnnotationLegend type="outline" /> are people who have.
      </>
    ),
    content2: (
      <>
        <b
          style={{
            color: "#ff0000",
            background:
              "linear-gradient(180deg, hsla(0, 0%, 100%, 0) 65%, #d1d1d1 0)",
            fontWeight: 700,
          }}>
          This line
        </b>{" "}
        is the cutoff for a person to rank as high risk. People who have not
        passed a Dutch language requirement are <b>almost twice as likely</b> to
        be categorized as high risk of committing fraud as those who have
        passed.
      </>
    ),
  },
  // {
  //   id: "lang-req-3",
  //   content: (
  //     <>
  //       People who have not passed a Dutch language requirement are almost twice
  //       as likely to be flagged for a fraud investigation as those who did.
  //     </>
  //   ),
  // },
  {
    id: "parent-1",
    content: (
      <>
        Having children can have a major impact on your risk score. Parents{" "}
        <AnnotationLegend type="parenthoodFill" /> are a little more than{" "}
        <b>two times more likely</b> to be categorized as high risk of
        committing fraud than non-parents.
      </>
    ),
  },
]

export const ANIM_STATE = distribution_annotations
  .map((d) => d.id)
  .reduce((ac, a, i) => ({ ...ac, [i]: a }), {})
